export default __webpack_public_path__ + "static/media/img (2).d244b4bd.jpg";